import { useWoodprices } from "../context/Woodprices";
import { useDemoMinskogStore } from "../../store/DemoMinskogStore";

import Skeleton from "../../comps/Skeleton";
import { Input, Text, Icon } from "@ui-component-library";
import PlayIcon from '@assets/icons/play-circle.svg';
import TreeIcon from '@assets/treebula/icon.svg';

import Retry from "../../comps/RetryBlock";
import { DEMO_PROMPTS } from "../../constants/demoPrompts";

export default function Podcasts() {
  const { podcasts, fetchPodcasts } = useWoodprices();
  const { DemoBlockFunctionWrapper} = useDemoMinskogStore()

  if(podcasts === null) {
      return <Retry func={fetchPodcasts} />
  } else if (podcasts.length === 0) {
    return Array.from({ length: 5 }, (_) => {
      return <div className="flex items-center gap-2 px-4 py-3 max-w-full h-[75px]">
        <Skeleton className="h-4 w-[52px] h-[52px]" />
        <Skeleton className="flex flex-1 min-w-0 h-4 h-full" />
        <Skeleton className="h-4 w-[36px] h-[36px]" />
      </div>
    })
  } else {
    return <div className="flex flex-col px-4">
      {podcasts?.map((pod, index) => {
        const date = new Date(pod.published_date)
        const formattedDate = date.toLocaleDateString('sv-SE', {day: 'numeric', month: 'short'})
        return <div className={`p${index == 0 ? 'b' : 'y'}-3 ${(index+1) != podcasts.length ? 'border-b-1 border-[#E6E6E6]' : ''}`}>
          <div onClick={() => DemoBlockFunctionWrapper(() => {window.open(pod.url, '_blank')}, DEMO_PROMPTS.ARTICLES)} className='flex justify-between cursor-pointer gap-2 w-full max-w-full'>
            <div className='flex justify-center items-center rounded-md overflow-hidden bg-[linear-gradient(to_bottom,#2C8A82,#155B5C)]' style={{width: '52px', height: '52px'}}>
              <TreeIcon height='16px' width='24px' fill='#dfff5d' />
            </div>

            <div className='flex flex-col justify-evenly flex-1 min-w-0'>
              <Text className='truncate' variant='text-xs/leading-normal/medium'>{pod.title}</Text>

              <Text className='text-[#737373]' variant='text-2xs/leading-none/normal'>{formattedDate.slice(0, -1)}</Text>
            </div>
            
            <div className='flex flex-col justify-center'>
              <div className='bg-[#F5F5F5] rounded-lg p-2'>
                <PlayIcon height='20px' width='20px' />
              </div>
            </div>
          </div>
        </div>
      })}
    </div>
  }
}
